var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileAppDevelopmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C7.34315 17 6 15.8807 6 14.5C6 13.1193 7.34315 12 9 12",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 26C32.1569 26 33.5 24.8807 33.5 23.5C33.5 22.1193 32.1569 21 30.5 21",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22.8383H7.50351C7.23365 22.8439 6.97015 22.7553 6.75761 22.5873C6.54817 22.4221 6.40361 22.1873 6.34965 21.9246L6.05515 20.4955C5.79469 20.3687 5.54198 20.2263 5.29838 20.0691L3.89709 20.5357C3.7776 20.5736 3.653 20.5925 3.52775 20.5917C3.32626 20.5903 3.12834 20.5379 2.95203 20.4394C2.77755 20.3413 2.63183 20.1984 2.52959 20.0252L1.16692 17.7555C1.02526 17.5267 0.971127 17.2536 1.01468 16.9873C1.05823 16.7211 1.19647 16.4801 1.40349 16.3094L2.49338 14.9193V14.488L1.40228 13.5072C1.20079 13.3375 1.06616 13.1006 1.02277 12.8394C0.979376 12.5781 1.03008 12.3098 1.16571 12.083L2.52838 9.81455C2.63045 9.6409 2.77619 9.49758 2.95082 9.39911C3.12713 9.30063 3.32505 9.24828 3.52655 9.24682C3.65066 9.23891 3.77525 9.25042 3.89588 9.28093L5.26941 9.76825C5.51483 9.60987 5.7691 9.46814 6.03222 9.34306L6.32672 7.91399C6.38068 7.65128 6.52524 7.41642 6.73467 7.25123C6.94721 7.08328 7.21072 6.99462 7.48058 7.00025L9.5 7.00025",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.8383H31.9965C32.2663 31.8439 32.5299 31.7553 32.7424 31.5873C32.9518 31.4221 33.0964 31.1873 33.1503 30.9246L33.4448 29.4955C33.7053 29.3687 33.958 29.2263 34.2016 29.0691L35.6029 29.5357C35.7224 29.5736 35.847 29.5925 35.9722 29.5917C36.1737 29.5903 36.3717 29.5379 36.548 29.4394C36.7225 29.3413 36.8682 29.1984 36.9704 29.0252L38.3331 26.7555C38.4747 26.5267 38.5289 26.2536 38.4853 25.9873C38.4418 25.7211 38.3035 25.4801 38.0965 25.3094L37.0066 23.9193V23.488L38.0977 22.5072C38.2992 22.3375 38.4338 22.1006 38.4772 21.8394C38.5206 21.5781 38.4699 21.3098 38.3343 21.083L36.9716 18.8146C36.8695 18.6409 36.7238 18.4976 36.5492 18.3991C36.3729 18.3006 36.1749 18.2483 35.9735 18.2468C35.8493 18.2389 35.7248 18.2504 35.6041 18.2809L34.2306 18.7683C33.9852 18.6099 33.7309 18.4681 33.4678 18.3431L33.1733 16.914C33.1193 16.6513 32.9748 16.4164 32.7653 16.2512C32.5528 16.0833 32.2893 15.9946 32.0194 16.0003L30 16.0003",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 35.5C9.5 35.5 22.299 35.5 30.5 35.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22C14 22 21.3137 22 26 22",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26C14 26 21.3137 26 26 26",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30C14 30 21.3137 30 26 30",
    stroke: "white",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5C9.5 5 22.299 5 30.5 5",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 0.5,
    width: 21,
    height: 39,
    rx: 2.5,
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10L15.3568 11.652C14.7301 12.0437 14.7301 12.9563 15.3568 13.348L18 15",
    stroke: "white",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10L25.6432 11.652C26.2699 12.0437 26.2699 12.9563 25.6432 13.348L23 15",
    stroke: "white",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9L20 16",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppDevelopmentIcon);
export default __webpack_public_path__ + "static/media/mobileAppDevelopmentIcon.97a4d79e92138899a740c0084694ca32.svg";
export { ForwardRef as ReactComponent };